import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = ['hideSideBarClick', 'lockSideBarClick', 'scheduleCallCSClick', 'settingsAndMembersClick'] as const;

export const sidebarEvents = getMappedEvents([...EVENTS]);
